var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterestReceivedActivityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 11,
    fill: "#FFEEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6779_1491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4813 27.852C50.199 27.6665 49.8429 27.6357 49.5329 27.7695L33.3733 34.7541L18.3582 27.7804C18.0477 27.6365 17.6853 27.6606 17.3966 27.8447C17.1082 28.0287 16.9336 28.3475 16.9336 28.6896V47.8678C16.9336 48.4214 17.3824 48.8701 17.9359 48.8701H49.9306C50.4844 48.8701 50.9331 48.4214 50.9331 47.8678V28.6896C50.9331 28.3521 50.7632 28.0372 50.4813 27.852Z",
    fill: "#E60000",
    fillOpacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4812 27.852C50.199 27.6665 49.8428 27.6357 49.5329 27.7695L33.3733 34.7541L33.3652 34.7505V48.8701H49.9305C50.4843 48.8701 50.9331 48.4214 50.9331 47.8678V28.6896C50.9331 28.3521 50.7632 28.0372 50.4812 27.852Z",
    fill: "#FF7705",
    fillOpacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3313 19.9812C20.862 19.8881 20.3925 20.1389 20.2096 20.5807L17.0102 28.3059C16.8045 28.8024 17.0268 29.3725 17.5139 29.5987L20.7134 31.0846C20.848 31.1471 20.992 31.178 21.1357 31.178C21.3237 31.178 21.5113 31.125 21.675 31.0205C21.9634 30.8366 22.1383 30.5178 22.1383 30.1756V20.9643C22.1383 20.4863 21.8003 20.0746 21.3313 19.9812Z",
    fill: "#FF7705",
    fillOpacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8576 28.3059L47.6581 20.5807C47.475 20.1389 47.0055 19.8881 46.5362 19.9812C46.0672 20.0746 45.7295 20.4863 45.7295 20.9643V30.0724C45.7295 30.4099 45.8994 30.7248 46.1814 30.9103C46.3474 31.0192 46.5391 31.075 46.7318 31.075C46.8667 31.075 47.0021 31.0477 47.1295 30.9925L50.3289 29.6096C50.8319 29.3925 51.0672 28.812 50.8576 28.3059Z",
    fill: "#E60000",
    fillOpacity: 0.81
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.054 36.7631C33.1871 36.8243 33.33 36.855 33.4732 36.855C33.6097 36.855 33.7461 36.8272 33.8737 36.7714L47.7335 30.7313V16.1351C47.7335 15.5816 47.2847 15.1328 46.7309 15.1328H21.1351C20.5816 15.1328 20.1328 15.5816 20.1328 16.1351V30.8153L33.054 36.7631Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7311 15.1328H33.3652V36.849C33.4013 36.8529 33.4373 36.855 33.4734 36.855C33.6098 36.855 33.7463 36.8269 33.8739 36.7714L47.7337 30.7313V16.1351C47.7337 15.5816 47.2849 15.1328 46.7311 15.1328Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9333 19.8311C30.5352 19.8311 27.7705 22.5957 27.7705 25.9939C27.7705 29.392 30.5352 32.1567 33.9333 32.1567C37.3315 32.1567 40.0961 29.392 40.0961 25.9939C40.0961 22.5957 37.3315 19.8311 33.9333 19.8311Z",
    fill: "url(#paint0_linear_6779_1491)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9333 19.8311C30.5352 19.8311 27.7705 22.5957 27.7705 25.9939C27.7705 29.392 30.5352 32.1567 33.9333 32.1567C37.3315 32.1567 40.0961 29.392 40.0961 25.9939C40.0961 22.5957 37.3315 19.8311 33.9333 19.8311Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2584 28.1959C32.9962 28.1959 32.735 28.0934 32.5391 27.8919L31.0188 26.3266C30.6331 25.9295 30.6421 25.295 31.0393 24.9093C31.4364 24.5236 32.0712 24.5326 32.4569 24.9298L33.329 25.8278L35.4862 24.025C35.9108 23.6701 36.543 23.7264 36.8981 24.1513C37.2532 24.5762 37.1967 25.2084 36.7718 25.5635L33.901 27.9627C33.7142 28.1188 33.4859 28.1959 33.2584 28.1959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9333 19.8311C33.7419 19.8311 33.5523 19.8404 33.3652 19.8575V32.1302C33.5523 32.1474 33.7419 32.1567 33.9333 32.1567C37.3315 32.1567 40.0961 29.392 40.0961 25.9939C40.0961 22.5957 37.3315 19.8311 33.9333 19.8311Z",
    fill: "url(#paint1_linear_6779_1491)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9333 19.8311C33.7419 19.8311 33.5523 19.8404 33.3652 19.8575V32.1302C33.5523 32.1474 33.7419 32.1567 33.9333 32.1567C37.3315 32.1567 40.0961 29.392 40.0961 25.9939C40.0961 22.5957 37.3315 19.8311 33.9333 19.8311Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.898 24.1513C36.5429 23.7264 35.9107 23.6701 35.4861 24.025L33.3652 25.7975V28.1894C33.5564 28.1692 33.7434 28.0945 33.9009 27.9627L36.7717 25.5632C37.1966 25.2084 37.2531 24.5762 36.898 24.1513Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6779_1491",
    x1: 33.9333,
    y1: 19.8311,
    x2: 33.9333,
    y2: 32.1567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6779_1491",
    x1: 36.7307,
    y1: 19.8311,
    x2: 36.7307,
    y2: 32.1567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6779_1491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(17 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestReceivedActivityIcon);
export default __webpack_public_path__ + "static/media/InterestReceived-Activity-icon.920e24cb383a5d0d511ad22d534185e8.svg";
export { ForwardRef as ReactComponent };